import { asyncActionsCreator } from '../../global/redux';
import * as constants from './constants';

export const getRecipeInfo = asyncActionsCreator(constants.GET_RECIPE_INFO);
export const setRecipeNumber = asyncActionsCreator(constants.SET_RECIPE_NUMBER);
export const getSuitableMedications = asyncActionsCreator(
  constants.GET_SUITABLE_MEDICATIONS
);

export const checkProvision = asyncActionsCreator(constants.CHECK_PROVISION);
export const applyRecipe = asyncActionsCreator(constants.APPLY_RECIPE);

export const getRxGateCurrentReceipt = asyncActionsCreator(
  constants.GET_RXGATE_CURRENT_RECEIPT
);
export const setRxGateChosenReceipt = asyncActionsCreator(
  constants.SET_RXGATE_CHOSEN_RECEIPT
);
